import React, { useMemo } from "react";
import { useStore } from "@/context/StoreContext";
import ProductCard from "@/components/ProductCard";

const RecentlyViewed = ({ excludeId, limit = 8, className = "" }) => {
  const { recentlyViewed } = useStore();

  const items = useMemo(
    () => recentlyViewed.filter((p) => p.id !== excludeId).slice(0, limit),
    [recentlyViewed, excludeId, limit]
  );

  if (!items.length) return null;

  return (
    <section className={className} data-testid="recently-viewed">
      <div className="mb-8 sm:mb-10">
        <p className="overline mb-3">Recently viewed</p>
        <h2 className="editorial-h2">Pick up where you <span className="italic">left off</span></h2>
      </div>
      <div className="flex gap-4 lg:gap-6 overflow-x-auto no-scrollbar snap-x snap-mandatory -mx-4 px-4 sm:-mx-8 sm:px-8 lg:mx-0 lg:px-0 pb-1">
        {items.map((product, index) => (
          <div
            key={product.id}
            className="w-[42vw] sm:w-[30vw] md:w-[22vw] lg:w-[calc(25%-18px)] max-w-[300px] shrink-0 snap-start"
          >
            <ProductCard product={product} index={index} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
